var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinezarapricenewOptimized(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "katman_2",
    "data-name": "katman 2",
    viewBox: "0 0 960 560",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "katman_1",
    "data-name": "katman 1"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 579.48,
    y1: 251.99,
    x2: 680.62,
    y2: 251.99,
    fill: "none",
    stroke: "#1e1e1c",
    strokeMiterlimit: 10,
    strokeWidth: ".25px"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinezarapricenewOptimized);
export default __webpack_public_path__ + "static/media/linezarapricenew_optimized.44e1894cbf964b5e1e8183d0570ab222.svg";
export { ForwardRef as ReactComponent };